import { clearTemp } from '../prototypes/clearTemp';
import { loadMissingFontsFromNode } from './loadMissintFontsFromNode';

export const safeCreateNewInstance = async (
  component: ComponentNode,
  tempLayer: FrameNode
) => {
  try {
    const newInstance = component.createInstance();

    tempLayer.appendChild(newInstance);

    return newInstance;
  } catch (e) {
    const figmaError = e as Error;

    if (figmaError.message.includes('unloaded font')) {
      await loadMissingFontsFromNode(component);
    }

    clearTemp();
  }
};
